import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ActivationOverlayProps {
  onComplete: () => void;
}
const activationSteps = ['Initializing Account Intelligence…', 'Connecting to Knowledge Spaces…', 'Syncing Quad Data Streams…', 'Mapping Accounts…', 'Welcome to Quad Atlas'];
export function ActivationOverlay({
  onComplete
}: ActivationOverlayProps) {
  const [currentStep, setCurrentStep] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    if (currentStep < activationSteps.length) {
      const timer = setTimeout(() => {
        setCurrentStep(prev => prev + 1);
      }, 800);
      return () => clearTimeout(timer);
    } else {
      const completeTimer = setTimeout(() => {
        setIsComplete(true);
        setTimeout(onComplete, 500);
      }, 800);
      return () => clearTimeout(completeTimer);
    }
  }, [currentStep, onComplete]);
  return <AnimatePresence data-id="element-76">
      {!isComplete && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="fixed inset-0 z-[200] flex items-center justify-center overflow-hidden" data-id="element-77">
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#0A1A33] via-[#081526] to-[#060E1B]" data-id="element-78" />
          {/* Glow effect */}
          <motion.div className="absolute w-96 h-96 rounded-full bg-blue-500/20 blur-3xl" animate={{
        scale: [1, 1.2, 1],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-79" />
          {/* Activation text */}
          <div className="relative z-10 text-center space-y-6" data-id="element-80">
            <AnimatePresence mode="wait" data-id="element-81">
              {activationSteps.map((step, index) => index === currentStep && <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.4
          }} className="text-xl text-blue-300 font-medium tracking-wide font-sans" data-id="element-82">
                      {step}
                    </motion.div>)}
            </AnimatePresence>
            {/* Progress indicator */}
            <div className="flex justify-center gap-2 mt-8" data-id="element-83">
              {activationSteps.map((_, index) => <motion.div key={index} className="w-2 h-2 rounded-full" initial={{
            backgroundColor: 'rgba(30, 144, 255, 0.3)'
          }} animate={{
            backgroundColor: index <= currentStep ? 'rgba(30, 144, 255, 1)' : 'rgba(30, 144, 255, 0.3)',
            scale: index === currentStep ? 1.3 : 1
          }} transition={{
            duration: 0.3
          }} data-id="element-84" />)}
            </div>
          </div>
          {/* Particle field */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-85">
            {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-white rounded-full" style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`
        }} animate={{
          y: [-20, -100],
          opacity: [0, 0.6, 0]
        }} transition={{
          duration: 3 + Math.random() * 2,
          repeat: Infinity,
          delay: Math.random() * 2,
          ease: 'easeOut'
        }} data-id="element-86" />)}
          </div>
        </motion.div>}
    </AnimatePresence>;
}